import type { ITeaser } from '~~/types/local_types';
import collectionsConfig from '~~/configs/collections.config';

// invalidate frontend cache after 4 hours
// const getTimedCacheKey = (baseKey: string): string => {
//   const now = Date.now();
//   const timeoutTime = 60 * 4 * 60 * 1000; // 4 hours
//   const rounded = Math.floor(now / timeoutTime) * timeoutTime;
//   return `${baseKey}-${rounded}`;
// };

export default async function useMostRead(): Promise<Array<unknown> | undefined> {
  const { objectKeysToCamelCase } = formatUtils();
  const cms = useCms();

  // Check cache
  // const cacheKey = getTimedCacheKey('most-read-articles');
  const cache = useNuxtData('most-read-articles');
  let items = cache.data.value;

  const limit = 5;
  const sort = 'ranking';

  const collectionName: string = 'articles';
  const fields = collectionsConfig.mostReadTeaser;

  // no items, fetch some
  if (!items || items.length === 0) {
    try {
      items = await cms.readItems(collectionName, { fields, limit, sort });
      cache.data.value = [...items];
    } catch (error) {
      console.warn('Error fetching teasers:', error);
      items = [];
    }
  }

  return objectKeysToCamelCase(items) as ITeaser[];
}
